/**
 * Paises com DDI, para o seletor do telefone.
 *
 * Cobre o publico esperado da plataforma. Uma lista com os ~250 paises do
 * mundo exigiria campo de busca para ser usavel; quem nao esta aqui usa
 * "Outro pais" e informa o DDI a mao.
 */

/** Valor especial: o usuario informa o DDI a mao. */
export const OUTRO = 'XX';

export interface Pais {
  iso: string;
  nome: string;
  /** Vazio no OUTRO: o DDI vem do campo digitavel. */
  ddi: string;
  bandeira: string;
  exemplo: string;
  /** Digitos do numero, SEM o DDI. Alguns paises aceitam dois tamanhos. */
  tamanhos: number[];
}

export const PAISES: Pais[] = [
  { iso: 'BR', nome: 'Brasil', ddi: '55', bandeira: '\u{1F1E7}\u{1F1F7}', exemplo: '11 98765-4321', tamanhos: [10, 11] },
  { iso: 'PT', nome: 'Portugal', ddi: '351', bandeira: '\u{1F1F5}\u{1F1F9}', exemplo: '912 345 678', tamanhos: [9] },
  { iso: 'AR', nome: 'Argentina', ddi: '54', bandeira: '\u{1F1E6}\u{1F1F7}', exemplo: '11 1234-5678', tamanhos: [10, 11] },
  { iso: 'BO', nome: 'Bolívia', ddi: '591', bandeira: '\u{1F1E7}\u{1F1F4}', exemplo: '71234567', tamanhos: [8] },
  { iso: 'CL', nome: 'Chile', ddi: '56', bandeira: '\u{1F1E8}\u{1F1F1}', exemplo: '9 1234 5678', tamanhos: [9] },
  { iso: 'CO', nome: 'Colômbia', ddi: '57', bandeira: '\u{1F1E8}\u{1F1F4}', exemplo: '300 1234567', tamanhos: [10] },
  { iso: 'EC', nome: 'Equador', ddi: '593', bandeira: '\u{1F1EA}\u{1F1E8}', exemplo: '99 123 4567', tamanhos: [9] },
  { iso: 'PY', nome: 'Paraguai', ddi: '595', bandeira: '\u{1F1F5}\u{1F1FE}', exemplo: '981 123456', tamanhos: [9] },
  { iso: 'PE', nome: 'Peru', ddi: '51', bandeira: '\u{1F1F5}\u{1F1EA}', exemplo: '912 345 678', tamanhos: [9] },
  { iso: 'UY', nome: 'Uruguai', ddi: '598', bandeira: '\u{1F1FA}\u{1F1FE}', exemplo: '99 123 456', tamanhos: [8] },
  { iso: 'VE', nome: 'Venezuela', ddi: '58', bandeira: '\u{1F1FB}\u{1F1EA}', exemplo: '412 1234567', tamanhos: [10] },
  { iso: 'US', nome: 'Estados Unidos', ddi: '1', bandeira: '\u{1F1FA}\u{1F1F8}', exemplo: '212 555 0123', tamanhos: [10] },
  { iso: 'CA', nome: 'Canadá', ddi: '1', bandeira: '\u{1F1E8}\u{1F1E6}', exemplo: '416 555 0123', tamanhos: [10] },
  { iso: 'MX', nome: 'México', ddi: '52', bandeira: '\u{1F1F2}\u{1F1FD}', exemplo: '55 1234 5678', tamanhos: [10] },
  { iso: 'PA', nome: 'Panamá', ddi: '507', bandeira: '\u{1F1F5}\u{1F1E6}', exemplo: '6123 4567', tamanhos: [8] },
  { iso: 'CR', nome: 'Costa Rica', ddi: '506', bandeira: '\u{1F1E8}\u{1F1F7}', exemplo: '8312 3456', tamanhos: [8] },
  { iso: 'ES', nome: 'Espanha', ddi: '34', bandeira: '\u{1F1EA}\u{1F1F8}', exemplo: '612 345 678', tamanhos: [9] },
  { iso: 'GB', nome: 'Reino Unido', ddi: '44', bandeira: '\u{1F1EC}\u{1F1E7}', exemplo: '7400 123456', tamanhos: [10] },
  { iso: 'IE', nome: 'Irlanda', ddi: '353', bandeira: '\u{1F1EE}\u{1F1EA}', exemplo: '85 123 4567', tamanhos: [9] },
  { iso: 'FR', nome: 'França', ddi: '33', bandeira: '\u{1F1EB}\u{1F1F7}', exemplo: '6 12 34 56 78', tamanhos: [9] },
  { iso: 'DE', nome: 'Alemanha', ddi: '49', bandeira: '\u{1F1E9}\u{1F1EA}', exemplo: '1512 3456789', tamanhos: [10, 11] },
  { iso: 'IT', nome: 'Itália', ddi: '39', bandeira: '\u{1F1EE}\u{1F1F9}', exemplo: '312 345 6789', tamanhos: [9, 10] },
  { iso: 'NL', nome: 'Países Baixos', ddi: '31', bandeira: '\u{1F1F3}\u{1F1F1}', exemplo: '6 12345678', tamanhos: [9] },
  { iso: 'BE', nome: 'Bélgica', ddi: '32', bandeira: '\u{1F1E7}\u{1F1EA}', exemplo: '470 12 34 56', tamanhos: [9] },
  { iso: 'CH', nome: 'Suíça', ddi: '41', bandeira: '\u{1F1E8}\u{1F1ED}', exemplo: '78 123 45 67', tamanhos: [9] },
  { iso: 'AT', nome: 'Áustria', ddi: '43', bandeira: '\u{1F1E6}\u{1F1F9}', exemplo: '664 123456', tamanhos: [9, 10] },
  { iso: 'SE', nome: 'Suécia', ddi: '46', bandeira: '\u{1F1F8}\u{1F1EA}', exemplo: '70 123 45 67', tamanhos: [9] },
  { iso: 'NO', nome: 'Noruega', ddi: '47', bandeira: '\u{1F1F3}\u{1F1F4}', exemplo: '406 12 345', tamanhos: [8] },
  { iso: 'DK', nome: 'Dinamarca', ddi: '45', bandeira: '\u{1F1E9}\u{1F1F0}', exemplo: '20 12 34 56', tamanhos: [8] },
  { iso: 'FI', nome: 'Finlândia', ddi: '358', bandeira: '\u{1F1EB}\u{1F1EE}', exemplo: '41 2345678', tamanhos: [9] },
  { iso: 'PL', nome: 'Polônia', ddi: '48', bandeira: '\u{1F1F5}\u{1F1F1}', exemplo: '512 345 678', tamanhos: [9] },
  { iso: 'CZ', nome: 'Tchéquia', ddi: '420', bandeira: '\u{1F1E8}\u{1F1FF}', exemplo: '601 123 456', tamanhos: [9] },
  { iso: 'RO', nome: 'Romênia', ddi: '40', bandeira: '\u{1F1F7}\u{1F1F4}', exemplo: '712 345 678', tamanhos: [9] },
  { iso: 'GR', nome: 'Grécia', ddi: '30', bandeira: '\u{1F1EC}\u{1F1F7}', exemplo: '691 234 5678', tamanhos: [10] },
  { iso: 'AO', nome: 'Angola', ddi: '244', bandeira: '\u{1F1E6}\u{1F1F4}', exemplo: '923 123 456', tamanhos: [9] },
  { iso: 'MZ', nome: 'Moçambique', ddi: '258', bandeira: '\u{1F1F2}\u{1F1FF}', exemplo: '82 123 4567', tamanhos: [9] },
  { iso: 'ZA', nome: 'África do Sul', ddi: '27', bandeira: '\u{1F1FF}\u{1F1E6}', exemplo: '71 123 4567', tamanhos: [9] },
  { iso: 'AE', nome: 'Emirados Árabes', ddi: '971', bandeira: '\u{1F1E6}\u{1F1EA}', exemplo: '50 123 4567', tamanhos: [9] },
  { iso: 'IL', nome: 'Israel', ddi: '972', bandeira: '\u{1F1EE}\u{1F1F1}', exemplo: '50 123 4567', tamanhos: [9] },
  { iso: 'IN', nome: 'Índia', ddi: '91', bandeira: '\u{1F1EE}\u{1F1F3}', exemplo: '98765 43210', tamanhos: [10] },
  { iso: 'CN', nome: 'China', ddi: '86', bandeira: '\u{1F1E8}\u{1F1F3}', exemplo: '131 2345 6789', tamanhos: [11] },
  { iso: 'JP', nome: 'Japão', ddi: '81', bandeira: '\u{1F1EF}\u{1F1F5}', exemplo: '90 1234 5678', tamanhos: [10] },
  { iso: 'SG', nome: 'Singapura', ddi: '65', bandeira: '\u{1F1F8}\u{1F1EC}', exemplo: '8123 4567', tamanhos: [8] },
  { iso: 'AU', nome: 'Austrália', ddi: '61', bandeira: '\u{1F1E6}\u{1F1FA}', exemplo: '412 345 678', tamanhos: [9] },
  { iso: 'NZ', nome: 'Nova Zelândia', ddi: '64', bandeira: '\u{1F1F3}\u{1F1FF}', exemplo: '21 123 4567', tamanhos: [8, 9] },
  { iso: OUTRO, nome: 'Outro pais', ddi: '', bandeira: '\u{1F310}', exemplo: 'numero local', tamanhos: [15] },
];

export const PAIS_PADRAO = 'BR';

export function acharPais(iso: string): Pais {
  return PAISES.find((p) => p.iso === iso) ?? PAISES[0];
}

/**
 * Descobre o pais a partir de um numero E.164 ja salvo.
 *
 * Ignora o "Outro" (ddi vazio casaria com tudo) e testa o DDI mais longo
 * primeiro: +55 e +598 se confundiriam do contrario.
 */
export function paisDoE164(e164: string): { pais: Pais; local: string; ddi: string } {
  const digitos = (e164 || '').replace(/\D/g, '');
  const ordenados = [...PAISES]
    .filter((p) => p.ddi)
    .sort((a, b) => b.ddi.length - a.ddi.length);

  for (const p of ordenados) {
    if (digitos.startsWith(p.ddi)) {
      return { pais: p, local: digitos.slice(p.ddi.length), ddi: p.ddi };
    }
  }
  // DDI desconhecido: a maioria tem 1 a 3 digitos; 2 e o chute menos ruim.
  return { pais: acharPais(OUTRO), local: digitos.slice(2), ddi: digitos.slice(0, 2) };
}
